class OAuth2 {
  constructor() {
    this.baseURL = this.getPortalURL();
    this.oauthAppId = 'icea-lion-product-calculators-oauth-application-user-agent';
  }

  /**
   * Get portal URL - dynamically determine based on environment
   */
  getPortalURL() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getPortalURL();
    }
    return window.location.origin;
  }

  /**
   * Get CSRF token from Liferay
   */
  getCsrfToken() {
    if (typeof window !== 'undefined' && window.Liferay) {
      return window.Liferay.authToken;
    }
    return '';
  }

  /**
   * Check if user is signed in
   */
  isUserSignedIn() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.isSignedIn();
    }
    return false;
  }

  /**
   * Get dynamic API endpoint with current scope group ID
   */
  getEndpoint() {
    const scopeGroupId = this.getScopeGroupId();
    return `${this.endpointBase}${scopeGroupId}`;
  }

  /**
   * Get scope group ID from Liferay ThemeDisplay
   */
  getScopeGroupId() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getScopeGroupId();
    }
    return '250023'; // fallback
  }

  /**
   * Get user information
   */
  getUser() {
    const user = { scopeGroupId: this.getScopeGroupId() };
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      user.userId = window.Liferay.ThemeDisplay.getUserId();
      user.isSignedIn = window.Liferay.ThemeDisplay.isSignedIn();
    }
    return user;
  }

  /**
   * Get OAuth2 access token using client credentials flow
   */
  async getAccessToken() {
  try {
    const response = await fetch("/o/tokenService/get-token", {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Token request failed: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    return result?.data?.accessToken || null;

  } catch (error) {
    console.error("Error fetching access token:", error);
    return null;
  }
}

  /**
   * Get standard headers for API requests (including Authorization if available)
   */
  async getHeaders() {
    const token = await this.getAccessToken();

    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }
}

export default OAuth2;